(function () {
  'use strict';

  /* Desktop mega menus — JS-driven hover (with close delay to bridge the
     gap between the trigger and the panel) + click toggle + outside close */
  function initMega() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-nh-mega-item]'));
    if (!items.length) return;

    var closeTimer = null;
    var CLOSE_DELAY = 180; // ms — lets the cursor cross the gap without closing

    function isDesktop() {
      return window.matchMedia('(min-width: 1101px)').matches;
    }

    function openItem(item) {
      clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
      var t = item.querySelector('[data-nh-mega-trigger]');
      if (t) t.setAttribute('aria-expanded', 'true');
    }

    function closeItem(item) {
      item.classList.remove('is-open');
      var t = item.querySelector('[data-nh-mega-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }

    function closeAll(except) {
      items.forEach(function (it) {
        if (it !== except) closeItem(it);
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-nh-mega-trigger]');
      if (!trigger) return;

      // Hover: open on enter (trigger OR panel, since panel is a descendant),
      // close after a short delay on leave so the gap transit doesn't close it.
      item.addEventListener('pointerenter', function () {
        if (!isDesktop()) return;
        openItem(item);
      });
      item.addEventListener('pointerleave', function () {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { closeItem(item); }, CLOSE_DELAY);
      });

      // Click toggle (touch / keyboard)
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.classList.contains('is-open');
        clearTimeout(closeTimer);
        closeAll(item);
        if (isOpen) {
          closeItem(item);
        } else {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (e) {
      var inside = items.some(function (it) { return it.contains(e.target); });
      if (!inside) closeAll(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* Mobile drawer */
  function initDrawer() {
    var drawer = document.querySelector('[data-nh-drawer]');
    if (!drawer) return;
    var panel = drawer.querySelector('.nh-drawer__panel');

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-nh-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    document.querySelectorAll('[data-nh-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    // Accordion items (Shop All / Categories)
    var accItems = Array.prototype.slice.call(drawer.querySelectorAll('[data-nh-drawer-item]'));
    accItems.forEach(function (item) {
      var btn = item.querySelector('[data-nh-accordion]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        // close others
        accItems.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var ob = other.querySelector('[data-nh-accordion]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* Search — open Horizon search modal if available */
  function initSearch() {
    document.querySelectorAll('[data-nh-search]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var modal = document.querySelector('#search-modal, search-modal');
        if (modal && typeof modal.showDialog === 'function') { modal.showDialog(); return; }
        var hidden = document.querySelector('.header-section [data-search-toggle], .header-section search-toggle');
        if (hidden) { hidden.click(); return; }
        window.location.href = '/search';
      });
    });
  }

  /* Cart — open Rebuy or Horizon cart drawer */
  function initCart() {
    document.querySelectorAll('[data-nh-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.Rebuy && window.Rebuy.SmartCart) { window.Rebuy.SmartCart.show(); return; }
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.open === 'function') { cd.open(); return; }
        window.location.href = '/cart';
      });
    });
  }

  /* Cart count */
  function syncCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-nh-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.style.display = c.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }

  /* When the quiz is triggered, close any open drawer (our menu drawer AND the
     cart drawer) so the Quiz Kit popup isn't hidden behind them (z-index fix). */
  function initQuizFix() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('a[href*="quiz-kit-key"], .nh-drawer__quiz-btn');
      if (!trigger) return;

      // Close our mobile menu drawer
      var drawer = document.querySelector('[data-nh-drawer]');
      if (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      }

      // Close the cart drawer if one is open (Rebuy or Horizon)
      try {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.hide === 'function') {
          window.Rebuy.SmartCart.hide();
        }
        var cd = document.querySelector('cart-drawer');
        if (cd) {
          if (typeof cd.close === 'function') cd.close();
          else cd.removeAttribute('open');
        }
      } catch (err) {}

      // Restore page scroll (drawers lock body scroll)
      document.body.style.overflow = '';
    }, true);
  }

  function init() {
    if (!document.querySelector('[data-new-header]')) return;
    initMega();
    initDrawer();
    initSearch();
    initCart();
    syncCartCount();
    initQuizFix();
    document.addEventListener('cart:refresh', syncCartCount);
    document.addEventListener('cart:update', syncCartCount);
    document.addEventListener('cart-update', syncCartCount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
